import axios from 'axios';

const state = function () {
    return {
        order: [{
            value: 'id',
            sort: 'desc'
        }],
        items: [],
        limit: 50,
        currentPage: 1,
        page: 1,
        totalItems: 0,
        fetchRoute: null,
        unreadCount: 0,
    };
};

const mutations = {
    SET_ITEMS(state, data) {
        state.items = data;
    },
    UPDATE_ITEM(state, {
        id,
        data
    }) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        if (index != -1) {
            state.items[index] = state.items[index].update(data);
        }
    },
    REMOVE_ITEM(state, id) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        state.items.splice(index, 1);
    },
    SET_META(state, data) {
        state.totalItems = data.total;
        state.limit = data.per_page;
    },
    SET_UNREAD_COUNT(state, data) {
        state.unreadCount = data
    },
    SET_ORDER(state, data) {
        state.order = [data]
    },
    SET_PAGE(state, data) {
        state.page = data
    },
};

const actions = {
    setOrder({
        commit,
        dispatch
    }, data) {
        commit('SET_ORDER', data)
        return dispatch('fetch')
    },
    setPage({
        commit
    }, data) {
        commit('SET_PAGE', data)
        return dispatch('fetch')
    },
    updateInList({
        commit,
        state
    }, {
        id,
        data
    }) {
        commit('UPDATE_ITEM', {
            id,
            data
        })
    },
    removeInList({
        commit
    }, id) {
        commit('REMOVE_ITEM', id)
    },
    fetch({
        commit,
        state
    }, params) {
        let mergedParams = {
            mode: 'list',
            ...params
        }
        return axios.get('/notifications', {
            params: mergedParams
        }).then((r) => {
            commit('SET_ITEMS', r.data.data)
            if( r.data.meta ) {
                commit('SET_META', r.data.meta)
            }
            commit('SET_UNREAD_COUNT', r.data.include.unreadCount)
        })
    },
    read({
        commit,
        state
    }, noty) {
        let params = {
            mode: 'read',
        }
        return axios.post('/notifications/' + noty.id, params).then((r) => {
            commit('REMOVE_ITEM', noty.id)
            commit('SET_UNREAD_COUNT', state.unreadCount - 1)
        })
    },
    readAll({
        commit,
        state
    }) {
        return axios.post('/notifications/readAll').then((r) => {
            commit('SET_ITEMS', [])
            commit('SET_UNREAD_COUNT', 0)
        })
    },
};

const getters = {
    order: (state) => state.order,
    items: (state) => state.items,
    limit: (state) => state.limit,
    currentPage: (state) => state.currentPage,
    totalItems: (state) => state.totalItems,
    unreadCount: (state) => state.unreadCount
};

let moduleStore = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default moduleStore;
